import { Box, styled } from '@mui/joy';

import { TAB_FULL_SCREEN_WIDTH, TAB_FULL_WIDTH } from 'theme/constants';

const propsToSkip: PropertyKey[] = ['fullWidth', 'fullScreen'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

export const ContentWrapper = styled(Box, {
  shouldForwardProp,
})(({ fullWidth, fullScreen }: { fullWidth: boolean; fullScreen: boolean }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: '16px',
  backgroundColor: 'inherit',

  ...(fullWidth && {
    ['@media (min-width: 1610px)']: {
      width: 1440,
    },

    ['@media (max-width: 1610px)']: {
      width: TAB_FULL_WIDTH,
    },
  }),

  ...(fullScreen && {
    width: TAB_FULL_SCREEN_WIDTH,
  }),
}));
